import PasswordResetRequest from "../Components/Login/PasswordResetRequest";

const PasswordResetRequestPage = () => {
  return <PasswordResetRequest />;
};

export default PasswordResetRequestPage;
